import React from "react";
import { Field } from "formik";
import { phoneMask } from "../../../utils/form/phoneMask";

import styles from "./PhoneInput.module.scss";

import { FieldPropsType, PhoneInputPropsType } from "./types";

export const PhoneInput: React.FC<PhoneInputPropsType> = (props) => {
  const { name, focusThisInput = false, placeholder, lable } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (focusThisInput) {
      inputRef.current?.focus();
    }
  }, []);

  return (
    <Field name={name}>
      {(fieldProps: FieldPropsType) => {
        const { field, form, meta } = fieldProps;
        const hasValue = !!meta.value && meta.value.length > 0;

        return (
          <div className={styles.inputWrapper}>
            <label
              htmlFor={name}
              className={`
                ${styles.label}
                ${meta.touched && meta.error ? styles.error : null}
              `}>
              {lable}
            </label>
            <input
              ref={inputRef}
              type="tel"
              id={name}
              inputMode="numeric"
              placeholder={placeholder}
              className={`
                ${styles.input}
                ${meta.touched && meta.error ? styles.error : null}
              `}
              {...field}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                form.setFieldValue(name, phoneMask(e));
              }}
            />
          </div>
        );
      }}
    </Field>
  );
};
